import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'

export const RcnHtml =
'<div class="form-group text-left mt-2">' +
  '<label for="rcn-title">' + lang.Rcn_html_label_title + '</label>' +
  '<input type="text" id="rcn-title" class="form-control">' +
'</div>' +

'<div class="form-group text-left mt-2 d-none">' +
  '<label for="rcn-recursion-type">' + lang.Rcn_html_recursion_type + '</label>' +
  '<select id="rcn-recursion-type" class="form-control select2">' +
  '<option value="daily">' +lang.Rcn_html_daily+ '</option>' +
  '<option value="weekly">' +lang.Rcn_html_weekly+ '</option>' +
  '<option value="monthly">' +lang.Rcn_html_monthly+ '</option>' +
  '</select>' +
'</div>' +

'<div class="form-group text-left mt-2">' +
  '<label for="rcn-postbackId">' + lang.Rcn_html_label_postback_id + '</label>' +
  '<select id="rcn-postbackId" class="form-control select2"></select>' +
'</div>' +

'<div id="file-upload-media-url-group" class="form-group text-left mt-2">' + 
  '<label for="file-upload-media-url">' + lang.Rcn_html_label_img_media_url + '</label>' +
  '<input type="text" class="form-control" id="file-upload-media-url" placeholder="' + lang.image_html_placeholder_img_url + '">' +
'</div>' +

'<div class="form-group fb-file-upload mt-4">' +
  '<div id="file-upload-dropzone" class="dropzone d-flex justify-content-center align-items-center mb-1">' +
    '<div class="dz-default dz-message">' +
      '<input type="file" class="d-none" name="uploaded-file-img" id="uploaded-file-img">' +
      '<span class="fas fa-cloud-upload-alt"></span>' +
    '</div>' +
  '</div>' +
  '<span class="text-small text-muted">' + lang.image_html_info_supported_media + '</span>' +
'</div>' +

// Adds html for delay system
delayHtml
